<template>
  <div class="houselist">
    <span style="font-size: 45px;color: red">这是楼盘列表</span>
  </div>
</template>

<script>
export default {
  name: "houselist"
}
</script>

<style lang="sass" scoped>
  .houselist

</style>
